import React from 'react';

import { Typography } from '@vtblife/uikit';

import { ClOfferList } from '../../list/ClOfferList';
import { ClOfferListCount } from '../../list/ClOfferListCount';
import { ClOfferListPage } from '../../list/ClOfferListPage';
import { ClOfferSnippet } from '../../snippet/ClOfferSnippet';
import { ClOfferSnippetEmpty } from '../../snippet/empty/ClOfferSnippetEmpty';

export function ClOfferCardNotFound({
    children,
    count,
    title,
    goToRelativeOffers
}: {
    title: React.ReactNode;
    goToRelativeOffers(): void;
    count?: number;
    children: React.ReactNode;
}) {
    return (
        <ClOfferListPage>
            <ClOfferSnippet border>
                <ClOfferSnippetEmpty size='m' onClick={goToRelativeOffers} />
            </ClOfferSnippet>
            <Typography variant='h2' responsive>{title}</Typography>
            <ClOfferListCount count={count} />
            <ClOfferList>
                {children}
            </ClOfferList>
        </ClOfferListPage>
    );
}
